import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './LandingPage';
import InvoiceGen from './InvoiceGen';
import Matrimony from './Matrimony';
import DnyanaaiAstrology from './DnyanaaiAstrology';
import BragPage from './BragPage';
import BrilliantShareMarket from './BrilliantShareMarket';
import './App.css';

// Client sites hosted elsewhere. Netlify 301s direct visits (public/_redirects);
// this covers in-app navigation, which never reaches the server.
function ExternalRedirect({ to, name }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
      <p>Redirecting to {name}...</p>
      <a href={to}>Click here if not redirected</a>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/studio" element={<LandingPage />} />
            <Route path="/brag" element={<BragPage />} />
            <Route path="/invoicegen" element={<InvoiceGen />} />
            <Route path="/matrimony" element={<Matrimony />} />
            <Route path="/atulya/*" element={<ExternalRedirect to="http://atulyayuvafoundation.com/" name="Atulya Yuva Foundation" />} />
            <Route path="/astrology" element={<DnyanaaiAstrology />} />
            <Route path="/brilliantsharemarket" element={<BrilliantShareMarket />} />
            <Route path="/sharemarket" element={<BrilliantShareMarket />} />
            <Route path="/nststudio/*" element={<ExternalRedirect to="https://nststudioin.netlify.app/" name="NST Studio" />} />
            <Route path="/nst" element={<ExternalRedirect to="https://nststudioin.netlify.app/" name="NST Studio" />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
